import axios from "./axios"

const url = "/user-roles"

const entityCaption = "User Role"

const fetchErrorMsg = `Error fetching ${entityCaption}`
const createErrorMsg = `Error creating ${entityCaption}:`
const editErrorMsg = `Error updating ${entityCaption}:`
const destroyErrorMsg = `Error deleting ${entityCaption}:`

const UserRoleApi = () => {
	const getByUserId = async (userId) => {
		try {
			const response = await axios.get(`${url}/get-user-roles`, {
				params: {
					user_id: userId,
				},
			})

			return response.data
		} catch (error) {
			console.error(fetchErrorMsg, error)
			throw error
		}
	}

	const create = async (entity) => {
		try {
			const response = await axios.post(url, entity)

			return response.data
		} catch (error) {
			console.error(createErrorMsg, error)
			throw error
		}
	}

	const edit = async (id, entity) => {
		try {
			const response = await axios.put(`${url}/${id}`, entity)

			return response.data
		} catch (error) {
			console.error(editErrorMsg, error)
			throw error
		}
	}

	const destroy = async (id) => {
		try {
			const response = await axios.delete(`${url}/${id}`)

			return response.data
		} catch (error) {
			console.error(destroyErrorMsg, error)
			throw error
		}
	}

	return {
		getByUserId,
		create,
		edit,
		destroy,
	}
}

export default UserRoleApi
